import { render, staticRenderFns } from "./ManualCrud.vue?vue&type=template&id=6b09f34e"
import script from "./ManualCrud.vue?vue&type=script&lang=js"
export * from "./ManualCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports